<template>
  <div class="btn-group">
    <label class="btn btn-primary" :class="{active: value, disabled: disabled}" @click="yes()">YES</label>
    <label class="btn btn-primary" :class="{active: !value, disabled: disabled}" @click="no()">NO</label>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    },

    value: {
      required: true
    }
  },

  methods: {
    yes() {
      if(this.disabled) return;

      this.$emit('input', true);
    },

    no() {
      if(this.disabled) return;

      this.$emit('input', false);
    },
  }
};
</script>

<style scoped>
  label {
    background-color: #fff;
    border-color: #ccc;
    border: none;
    border-radius: 3px;
  }

  label.active {
    background-color: #6f1b57;
    color: #ffffff !important;
  }

  label.btn-primary:hover {
    color: inherit;
    background-color: #fff;
    border-color: #ccc;
  }

  label.active.btn-primary:hover {
    background-color: #6f1b57;
    color: #ffffff !important;
  }
</style>
